import { type FC } from 'react'
import classNames from 'classnames'
import { type User } from '../../models/User'
import { UserAvatar } from './UserAvatar'
import { useUserAvatarSource } from './useUserAvatarSource'
import styles from './UserAvatarInline.module.scss'

export interface UserAvatarInlineProps {
  user?: User | null
  name?: string
  className?: string
}

export const UserAvatarInline: FC<UserAvatarInlineProps> = ({ user, name, className }) => {
  const { imageUrl, initialLetters } = useUserAvatarSource({ user, name })

  return (
    <UserAvatar
      aria-hidden='true'
      className={classNames(styles.avatar, 'zocks-bg-color-gray-900 zocks-text-white bold', className)}
      imageUrl={imageUrl}
      useInitials={!!initialLetters}
      initialLetters={initialLetters}
    />
  )
}
